var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page"}},[(_vm.profile && _vm.profile.id != null)?_c('Navbar',{attrs:{"profile":_vm.profile},on:{"logout":_vm.logout}}):_c('PlainNavbar'),_c('div',{class:_vm.profile?'':'login',style:(`${ _vm.showHospitalTag ? 'margin-bottom: 80px' : '' }`),attrs:{"id":"main"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }